import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import { useState } from 'react';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";
import { Subscription } from '../types';
import { BillingTabs } from '../../products/components/BillingTabs';

export const IndexPage = () => {
    const [selectedRecords, setSelectedRecords] = useState<Subscription[]>([]);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <BillingTabs />
                <RecordsTable
                    selectedRecords={selectedRecords}
                    setSelectedRecords={setSelectedRecords}
                />
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};


